/*
==========================================
店舗在庫確認用処理 (for Product page)
・main-product.liquidで"店舗在庫の確認"ブロックを設定した場合、読み込まれます。
==========================================
*/

// 初期表示処理 - 店舗一覧を取得
const contractId = "skcj382a6",
  accessTK = "c0e8252941689b7f995cc8f45da779f8";
let storeList = [],
  dealingStoreList = [];

// storeListInformation(=Shopifyに設定された店舗情報)の取得
// [
//   {
//     "id":23(スマレジID),
//     "sort_order":1(並び順)
//   }
// ]
let storeListInformation = null;
if (document.getElementById("store-list-information")) {
  storeListInformation = JSON.parse(
    document.getElementById("store-list-information").textContent
  );
  // storeListInformationの並び順を、sort_orderでソート
  storeListInformation = storeListInformation.sort((a, b) => {
    if (a?.sort_order < b?.sort_order) return -1;
    if (a?.sort_order > b?.sort_order) return 1;
    return 0;
  });
}

window.addEventListener("DOMContentLoaded", () => {
  const process = "store_ref";
  const params = {
    fields: ["storeId", "storeName"],
    conditions: [],
    order: null,
    limit: 100,
    page: 1,
    table_name: "Store",
  };
  fetch("https://webapi.smaregi.jp/access/", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      Accept: "application/json",
      "X-contract-id": contractId,
      "X-access-token": accessTK,
    },
    body: "proc_name=" + process + "&params=" + JSON.stringify(params),
    redirect: "follow",
  })
    .then((response) => response.json())
    .then((data) => {
      // 店舗一覧を取得
      let originalStoreList = data.result;
      renderStoreList(originalStoreList);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});

// 店舗一覧の表示
const renderStoreList = (originalStoreList) => {
  const storeListHTML = document.getElementById("stock-store-list");

  // 1. storeListInformationをループし、それをベースにdesignatedStoreListを作成
  // 2. storeListInformationにない店舗は、非表示店舗とみなして非表示
  const designatedStoreList = [];
  storeListInformation.forEach((item) => {
    const storeItem = originalStoreList.find(
      (store) => parseInt(store.storeId) === parseInt(item.id)
    );
    if (storeItem) {
      storeItem.storeBrand = item.brand?.length > 0 ? item.brand : "その他";
      designatedStoreList.push(storeItem);
    }
  });

  storeList = designatedStoreList;
  if (storeList.length > 0) {
    // ブランドごとにグループ化
    let groupingStoreList = storeList.reduce((acc, item) => {
      if (!acc[item.storeBrand]) {
        acc[item.storeBrand] = [];
      }
      acc[item.storeBrand].push(item);
      return acc;
    }, {});

    // ブランドが"その他"の場合、後ろに並べ替え
    if (groupingStoreList["その他"]) {
      const otherBrand = groupingStoreList["その他"];
      delete groupingStoreList["その他"];
      groupingStoreList["その他"] = otherBrand;
    }

    // ブランドごとにグループ化したものを、ブランドごとにアコーディオン表示になるようにHTMLに変換
    let storeListHTMLText = "";
    Object.keys(groupingStoreList).forEach((brand) => {
      groupingStoreList[brand].forEach((store) => {
        const storeLink = storeListInformation.find(info => parseInt(info.id) === parseInt(store.storeId) && info.link);
        let storeName = store.storeName === "サロモン名古屋店" ? "サロモン タカシマヤ ゲートタワーモール店"
          : store.storeName === "サロモンアウトレット酒々井店" ? "サロモン 酒々井プレミアム・アウトレット店"
          : store.storeName === "サロモン福岡店" ? "サロモン ワン・フクオカ・ビルディング店"
          : store.storeName === "サロモンアウトレット木更津店" ? "サロモン 三井アウトレットパーク木更津店"
          : store.storeName === "サロモン新丸ビル店" ? "サロモン 新丸ビル店"
          : store.storeName === "サロモン高尾店" ? "サロモン 東京 高尾店"
          : store.storeName === "サロモンみなとみらい店" ? "サロモンストア MARK IS みなとみらい"
          : store.storeName;
        storeName = storeName.replace("サロモン ", "サロモン").replace("サロモン", "サロモン ");
        storeListHTMLText += `<div class="c-store-list__line" data-store_id="${store.storeId}">
          <div class="c-store-list__line-name">${
            storeLink ? `<a href="${storeLink.link}" target="_blank" rel="noopener noreferrer">${storeName}</a>`
             : `${storeName}`
          }</div>
          <div class="c-store-list__line-stock"></div>
        </div>`;
      });
    });
    storeListHTML.innerHTML = storeListHTMLText;
  }
};

// 在庫情報の取得
const getStockStatus = (_productSystemId) => {
  // 在庫情報をFetchする
  const productId = _productSystemId;

  const process = "stock_ref";
  const params = {
    conditions: [
      {
        productId: productId,
      },
    ],
    order: null,
    limit: 100,
    page: 1,
    table_name: "Stock",
  };

  fetch("https://webapi.smaregi.jp/access/", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      Accept: "application/json",
      "X-contract-id": contractId,
      "X-access-token": accessTK,
    },
    body: "proc_name=" + process + "&params=" + JSON.stringify(params),
    redirect: "follow",
  })
    .then((response) => response.json())
    .then((data) => {
      const result = data.result;
      // 店舗情報の取得
      // ※在庫0の場合、resultに店舗情報が入らない
      storeList.forEach((itemStore) => {
        const storeItemInventory = result.find(
          (item) => item.storeId === itemStore.storeId
        );
        const storeInventory = document.querySelector(
          `[data-store_id="${itemStore.storeId}"] .c-store-list__line-stock`
        );
        let inventoryText = "";

        // 【取り扱いがあるかどうか】
        //   dealingStoreListを検索し、assignDivision==="0"の場合は取扱店舗
        //  - assignDivision = "0"の場合、取扱あり
        //  - assignDivision = "1"の場合、取扱なし
        if (
          dealingStoreList.find(
            (dealingStore) =>
              dealingStore.storeId === itemStore.storeId &&
              dealingStore.assignDivision === "0"
          )
        ) {
          // 取り扱いがある場合
          if (storeItemInventory?.stockAmount >= 5) {
            // 在庫情報を取得し、かつ5以上の場合、○
            inventoryText = `<svg class="check check--in-stock" xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" viewBox="0 0 21 21">
              <circle cx="10.5" cy="10.5" fill="none" r="8" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
            </svg><span>在庫あり</span>`;
          } else if (
            0 < storeItemInventory?.stockAmount &&
            storeItemInventory?.stockAmount <= 4
          ) {
            // 在庫情報を取得し、かつ1〜4の場合、△
            inventoryText = `<svg class="check check--few-remaining" width="10" height="10" xmlns="http://www.w3.org/2000/svg">
            <path d="M1,9 L5,1 L9,9 Z" stroke="currentColor" fill="none" stroke-width="1"/>
          </svg><span>残りわずか</span>`;
          } else {
            // 在庫情報が取得できない、もしくは0の場合、×
            inventoryText = `<svg class="check check--sold-out" xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" viewBox="0 0 24 24" >
              <path fill-rule="evenodd" d="M5.72 5.72a.75.75 0 011.06 0L12 10.94l5.22-5.22a.75.75 0 111.06 1.06L13.06 12l5.22 5.22a.75.75 0 11-1.06 1.06L12 13.06l-5.22 5.22a.75.75 0 01-1.06-1.06L10.94 12 5.72 6.78a.75.75 0 010-1.06z"/>
            </svg><span>在庫無し</span>`;
          }
        } else {
          // 取り扱いがない場合
          inventoryText = `<span class="available product few-remaining">取扱なし</span>`;
        }
        storeInventory.innerHTML = inventoryText;
      });
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};

// 取扱店舗情報の取得
const getDealingStore = (_productSystemId) => {
  // 取扱店舗情報をFetchする
  const productId = _productSystemId;

  const process = "product_ref";
  const params = {
    conditions: [
      {
        productId: productId,
      },
    ],
    order: null,
    limit: 100,
    page: 1,
    table_name: "ProductStore",
  };

  fetch("https://webapi.smaregi.jp/access/", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      Accept: "application/json",
      "X-contract-id": contractId,
      "X-access-token": accessTK,
    },
    body: "proc_name=" + process + "&params=" + JSON.stringify(params),
    redirect: "follow",
  })
    .then((response) => response.json())
    .then((data) => {
      const result = data.result;
      // 取扱店舗情報の取得
      dealingStoreList = result;
      if (result.length > 0) {
        getStockStatus(productId);
        alert("店舗在庫情報を更新しました");
      } else {
        alert("その商品の店舗在庫情報はありません。");
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};

// 商品メタフィールドから、商品コード取得
const getCodeByVariantMeta = (e) => {
  e.preventDefault();

  const variantSelector = document.getElementById("stock-variant-selector");

  if (
    variantSelector.value === "" &&
    variantSelector.querySelector("option[selected]").textContent ===
      "選択してください"
  ) {
    alert("商品を選択してください。");
  } else if (variantSelector.value === "") {
    alert("その商品の店舗在庫情報はありません。");
  } else {
    const itemSKU = variantSelector.value;
    const process = "product_ref";
    const params = {
      fields: ["productId"],
      conditions: [
        {
          productCode: itemSKU,
        },
      ],
      order: null,
      limit: 100,
      page: 1,
      table_name: "Product",
    };
    fetch("https://webapi.smaregi.jp/access/", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        Accept: "application/json",
        "X-contract-id": contractId,
        "X-access-token": accessTK,
      },
      body: "proc_name=" + process + "&params=" + JSON.stringify(params),
      redirect: "follow",
    })
      .then((response) => response.json())
      .then((data) => {
        const result = data.result;
        if (result.length > 0) {
          // 店舗一覧を表示
          const storeListElement = document.querySelector('.c-stock-modal-body__store-list');
          if (storeListElement) {
            storeListElement.style.display = 'block';
          }
          // 注意事項を表示
          const cautionElement = document.querySelector('.c-stock-modal-body__caution');
          if (cautionElement) {
            cautionElement.style.display = 'block';
          }
          getDealingStore(result[0].productId);
        } else {
          alert("その商品の店舗在庫情報はありません。");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
};

// モーダル表示ボタン
const openCheckStockModal = (e) => {
  e.preventDefault();
  const modal = document.getElementById("product-stock-modal");
  const buttonClose = document.getElementsByClassName(
    "c-stock-modal__close"
  )[0];

  modal.style.display = "block";

  buttonClose.addEventListener("click", modalClose);
  function modalClose() {
    modal.style.display = "none";
  }

  // モーダルコンテンツ以外がクリックされた時
  addEventListener("click", outsideClose);
  function outsideClose(e) {
    if (e.target == modal) {
      modal.style.display = "none";
    }
  }
};
